module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/206.46c61d9d.png";